import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { DonationmaintypeService } from '../../../../../app/shared/API-Service/services/donationmaintype.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-view-donation-main-type',
  templateUrl: './view-donation-main-type.component.html',
  styleUrls: ['./view-donation-main-type.component.css']
})
export class ViewDonationMainTypeComponent implements OnInit {
  Donationmaintype:object [] = [];
  constructor(private _DonationmaintypeService:DonationmaintypeService,private _Router:Router) { }

  ngOnInit(): void {
    this.getcountries();
  }

  getcountries(){
    this._DonationmaintypeService.GetDonationMainType().subscribe((res) => {
      this.Donationmaintype = res.data
    console.log(this.Donationmaintype);
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }

  update(data){
    this._DonationmaintypeService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertDonationmainType']);
    }

delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._DonationmaintypeService.DeleteDonationMainType(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getcountries();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
            console.log("completed");
          })
        }
      }) 
    }
}
